import { Col, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActionButton from "../../common/components/ActionButton";
import CleanButton from "../../common/components/CleanButton";
import Page from "../../common/components/Page";
import PageSummary from "../../common/components/PageSummary";
import { buildSummaryRequest } from "../../state/connect-api";
import { useGetCaseSummaryMutation } from "../../state/globalApi";
import { updateCaseMaster } from "../../state/globalStore";
import { RootState } from "../../store";
import useTrafficCriminalLookup from "../traffic-criminal/useTrafficCriminalLookup";
import CaseDetailTabs from "./case-detail-tabs";
import getConfigs from "../../GetConfigs";

const CaseDetail = () => {
  const [getCaseSummary, { data, isLoading }] = useGetCaseSummaryMutation();
  const { activeCaseNumber } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const { handleReturnToResult, handleNewQuery, handleFetchCaseBalance, paymentLoading, loading, handleEFile } = useTrafficCriminalLookup();
  const [activeTab, setActiveTab] = useState<string>("1");
  const configurations = getConfigs([
    "ctWebPayments",
    "ctShowBalancesLink",
    "ctEfile"
  ]);
  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const summary = await getCaseSummary(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ summary: summary }));
    };
    fetch();
  }, [activeCaseNumber, dispatch, getCaseSummary]);

  const handleSwitchBalanceTab = () => {
    setActiveTab("5");
  };

  const handleTabChange = (tabValue) => {
    setActiveTab(tabValue);
  };

  return (
    <Page>
      <Page.Title title="Case Details" icon="briefcase" />
      <Page.Toolbar>
        <CleanButton onClick={handleReturnToResult} icon="arrow-left" loading={loading}>
          Return To Results
        </CleanButton>
        <CleanButton icon="plus" onClick={handleNewQuery}>
          New Query
        </CleanButton>
      </Page.Toolbar>
      <Page.Content>
        <Row gutter={16}>
          <Col xl={5} lg={5} md={5} sm={24} xs={24}>
            <Space direction="vertical">
              <br />
              <PageSummary.Title title={data?.MAIN[0]?.CASE} subtitle={data?.MAIN[0]?.NAME} />
              {/* <PageSummary.Notes notes="Notes" /> */}
              <PageSummary.Actions>
                {configurations.ctWebPayments?.toLowerCase() === "true" && (
                  <ActionButton loading={paymentLoading || isLoading} icon="money-bill" onClick={() => handleFetchCaseBalance(data?.MAIN[0]?.CASE)}>
                    Make Payment
                  </ActionButton>
                )}
                {configurations.ctShowBalancesLink?.toLowerCase() === "true" && (
                  <ActionButton icon="dollar-sign" onClick={() => handleSwitchBalanceTab()}>
                    View Case Balances
                  </ActionButton>
                              )}
                {configurations.ctEfile?.toLowerCase() === "true" && (
                  <ActionButton loading={isLoading} icon="check" onClick={() => handleEFile()}>
                    E-File
                  </ActionButton>
                )}
              </PageSummary.Actions>
            </Space>
          </Col>
          <Col xl={19} lg={19} md={19} sm={24} xs={24}>
            <CaseDetailTabs activeTab={activeTab} handleTabChange={handleTabChange} />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default CaseDetail;
    